import React from "react";
// Styles
import styles from "./polaroid-image.module.css";

function HorizontalPolaroidImage(props) {
  const { image, caption, className = "", aspectRatio, onClick } = props;

  const handleOverlayContextMenu = (event) => {
    event.preventDefault();
  };

  return (
    <div
      className={`polaroid-image-h ${styles.polaroidFrame} ${styles.polaroidFrameHorizontal} boxShadow ${className}`}
      onClick={onClick}
    >
      <img
        src={image}
        className={`${styles.polaroidImageHorizontal} ${aspectRatio}`}
        draggable="false"
      />
      <p className={styles.polaroidCaption}>{caption}</p>
      <div
        className={styles.transparentOverlay}
        onContextMenu={handleOverlayContextMenu}
      />
    </div>
  );
}

export default HorizontalPolaroidImage;
